import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useSelector, useDispatch } from "react-redux";

import { Input, Button, Select } from "components";
import { Logo } from "icons";
import i18n from "configs/i18n";
import { WrapperErrorMessage, ErrorMessage } from "theme/CommonStyle";

import { LinkStyled } from "theme/CommonStyle";
import { ActionCreators } from "redux/rootActions";
import { LoginData } from "models/authentication";
import {
  selectIsLoading,
  selectErrorMessage,
} from "redux/authentication/authenticationStates";

const WrapperBottom = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  a: {
    ...LinkStyled(theme),
  },
}));

const schema = yup.object().shape({
  email: yup.string().trim().required("メールアドレスを入力してください"),
  password: yup.string().required("パスワードを入力してください"),
});

const Login: React.FC = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);
  const errorMessage = useSelector(selectErrorMessage);

  const { watch, handleSubmit, control, setValue } = useForm({
    resolver: yupResolver(schema),
  });

  const watchEmailField = watch("email");
  const watchPasswordField = watch("password");

  useEffect(() => {
    dispatch(ActionCreators.handleErrorAction(""));
  }, [watchEmailField, watchPasswordField]);

  const onSubmit = (data: any) => {
    const params: LoginData = {
      ...data,
    };
    dispatch(ActionCreators.loginUserAction(params));
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Controller
          control={control}
          name="email"
          render={({ field: { onChange }, fieldState: { error } }) => (
            <Input
              label="メールアドレス"
              type="email"
              onChange={onChange}
              error={error?.message}
              marginForm="0 0 20px 0"
              fs={16}
              fwLabel={500}
            />
          )}
        />
        <div style={{ position: "relative" }}>
          <Controller
            control={control}
            name="password"
            render={({ field: { onChange }, fieldState: { error } }) => (
              <Input
                label="パスワード"
                type="password"
                onChange={onChange}
                error={error?.message}
                marginForm="0 0 36px 0"
                fs={16}
                fwLabel={500}
                hasPasswordToggle
              />
            )}
          />
          {errorMessage && (
            <WrapperErrorMessage style={{ position: "relative", top: -30 }}>
              <ErrorMessage>{errorMessage}</ErrorMessage>
            </WrapperErrorMessage>
          )}
        </div>
        <Button
          name="ログイン"
          type="submit"
          background="#2F8CAE"
          color="#fff"
          bdr="6px"
          width="100%"
          margin="4px 0 40px 0"
          padding="8px 0px"
          border="none"
          fontWeight={700}
          fontSize={16}
          disabled={isLoading}
        />
      </form>
      <WrapperBottom>
        <Link to="/forgot-password">パスワードをお忘れのかた</Link>
        <Logo width={95} height={16} />
      </WrapperBottom>
    </>
  );
};

export default Login;
